var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"submit button",attrs:{"type":_vm.type},domProps:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }